import { CheckCircle2, AlertCircle, AlertTriangle } from "lucide-react"
import { cn } from "@/lib/utils"
import type { EvidenceStrength } from "@/stores/strategy-store"

interface ThemeEvidenceBadgeProps {
  strength: EvidenceStrength
  count: number
  className?: string
}

export function ThemeEvidenceBadge({ strength, count, className }: ThemeEvidenceBadgeProps) {
  if (strength === 'strong') {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium",
          "bg-[hsl(var(--status-success)/0.12)] text-[hsl(var(--status-success))]",
          className
        )}
      >
        <CheckCircle2 className="h-2.5 w-2.5" />
        Strong evidence{count > 0 ? ` · ${count} ${count === 1 ? 'source' : 'sources'}` : ''}
      </span>
    )
  }

  if (strength === 'partial') {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium",
          "bg-[hsl(var(--status-warning)/0.12)] text-[hsl(var(--status-warning))]",
          className
        )}
      >
        <AlertCircle className="h-2.5 w-2.5" />
        Partial evidence{count > 0 ? ` · ${count} source` : ''}
      </span>
    )
  }

  // 'gap'
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-xs font-medium",
        "bg-destructive/10 text-destructive",
        className
      )}
    >
      <AlertTriangle className="h-2.5 w-2.5" />
      Evidence gap
    </span>
  )
}
